module.exports = __webpack_public_path__ + "static/img/gpt46.ab99fb99.png";